import { useEffect, useMemo, useState } from "react";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { RBTable } from "@pallassystems/react-bootstrap-table";
import Breadcrumb from "app/components/Breadcrumb";
import { axios } from "fake-db/mock";

export default function PaySlip() {
  const [users, setUsers] = useState([]);
  const [showEyeMenu, setShowEyeMenu] = useState(false);

  const columns = useMemo(
    () => [
      { accessorKey: "netSalary", header: "Net Salary", searchable: true },
      { accessorKey: "salaryMonth", header: "Salary Month", searchable: true },
      { accessorKey: "payrollDate", header: "Payroll Date", searchable: true },
      { accessorKey: "status", header: "Status" },
      {
        accessorKey: "action",
        header: "action",
        Cell: ({ row }) => (
          <Button
            className="btn-icon d-flex align-items-center justify-content-center"
            style={{
              width: 36,
              height: 36,
              backgroundColor: "#ffc107",
              border: "none",
            }}
            onClick={() => handleDownload(row.original)}
          >
            <i className="i-File-CSV text-18 text-white"></i>
          </Button>
        ),
      },
    ],
    [],
  );

  const handleDownload = (rowData) => {
    const link = document.createElement("a");
    link.href = rowData.fileUrl;
    link.download = rowData.fileName || "file.csv";
    link.click();
  };

  useEffect(() => {
    axios
      .get("/api/user/all")
      .then((res) => {
        console.log("Payslip User API Response:", res.data);

        const salaries = ["₹50,000", "₹48,000", "₹52,000"];
        const months = ["January 2026", "December 2025", "February 2026"];
        const dates = ["16-01-2026", "16-12-2025", "16-02-2026"];
        const statusArr = ["Paid", "Paid", "Pending"];

        // Map all users; use % to repeat arrays for more users
        const list = (res.data || []).map((user, index) => ({
          netSalary: salaries[index % salaries.length],
          salaryMonth: months[index % months.length],
          payrollDate: dates[index % dates.length],
          status: statusArr[index % statusArr.length],
        }));

        setUsers(list);
      })
      .catch((err) => {
        console.error("Payslip User API Error:", err);

        //  static data
        setUsers([
          {
            netSalary: "₹50,000",
            salaryMonth: "January 2026",
            payrollDate: "16-01-2026",
            status: "Paid",
          },
          {
            netSalary: "₹48,000",
            salaryMonth: "December 2025",
            payrollDate: "16-12-2025",
            status: "Paid",
          },
          {
            netSalary: "₹52,000",
            salaryMonth: "February 2026",
            payrollDate: "16-02-2026",
            status: "Pending",
          },
        ]);
      });
  }, []);

  return (
    <section>
      {/* Breadcrumb + Buttons container */}
      <div className="d-flex align-items-center justify-content-between mb-3">
        <Breadcrumb
          routeSegments={[
            { name: "Dashboard", path: "/" },
            { name: "Employees", path: "/employees" },
            { name: "Payslip" },
          ]}
        />

        {/* Right-side buttons */}
        <div className="d-flex gap-2">
          <Button
            className="btn-icon d-flex align-items-center justify-content-center"
            style={{
              width: 36,
              height: 36,
              backgroundColor: "#f44336",
              border: "none",
            }}
          >
            <i className="i-File-Horizontal-Text text-18 text-white"></i>
          </Button>

          <Button
            className="btn-icon d-flex align-items-center justify-content-center"
            style={{
              width: 36,
              height: 36,
              backgroundColor: "#ffc107",
              border: "none",
            }}
          >
            <i className="i-File-CSV text-18 text-white"></i>
          </Button>

          <Button
            className="btn-icon d-flex align-items-center justify-content-center"
            style={{
              width: 36,
              height: 36,
              backgroundColor: "#007bff",
              border: "none",
            }}
          >
            <i className="i-Billing text-18 text-white"></i>
          </Button>

          {/* Eye button with dropdown */}
          <div style={{ position: "relative" }}>
            <Button
              onClick={() => setShowEyeMenu(!showEyeMenu)}
              style={{
                width: "48px",
                height: "36px",
                backgroundColor: "#7e57c2",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                padding: 0,
              }}
            >
              <i className="i-Eye text-white" style={{ fontSize: "18px" }}></i>
              <span
                style={{
                  width: 0,
                  height: 0,
                  borderLeft: "5px solid transparent",
                  borderRight: "5px solid transparent",
                  borderTop: "6px solid #fff",
                  marginTop: "2px",
                }}
              ></span>
            </Button>

            {showEyeMenu && (
              <div
                style={{
                  position: "absolute",
                  top: "44px",
                  right: 0,
                  width: "180px",
                  backgroundColor: "#7e57c2",
                  borderRadius: "10px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
                  padding: "6px 0",
                  zIndex: 9999,
                }}
              >
                {["Salary Month", "Payroll Date", "Status", "action"].map(
                  (item) => (
                    <div
                      key={item}
                      style={{
                        padding: "10px 16px",
                        color: "#fff",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background =
                          "rgba(255,255,255,0.15)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      {item}
                    </div>
                  ),
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Card body>
        <Card.Title>Payslip</Card.Title>

        {users.length > 0 && (
          <RBTable
            data={users}
            columns={columns}
            varient="primary"
            footer={{ enablePagination: true }}
            toolbar={{
              enableFilters: true,
              enableGlobalFilter: true,
              enableDensityToggle: true,
              enableExportButton: true,
            }}
          />
        )}
      </Card>
    </section>
  );
}